import classNames from "classnames/dedupe";
import React, { FC, useContext, ReactNode } from "react";
import { FiltersDropdownContext } from "./FiltersDropdownContext";
import DrawerMask from "../../../Utility/DrawerMask/DrawerMask";
import { ClearAll } from "../../../ActionsSelectors/Select/ClearAll/ClearAll";

export interface IClearAllButton {
  clearAllText?: string;
  clearAllCallback?: () => void;
}

export interface IDropdownMenuProps {
  position?: "left" | "right";
  // isVisible?: boolean;
  classes?: { root?: string };
  clearAll?: IClearAllButton;
  children?: ReactNode;
}

const DropdownMenu: FC<IDropdownMenuProps> = ({
  position = "left",
  clearAll,
  children,
  classes,
}) => {
  const { hovered, showDropdown, showDropdownOnClickOutside } = useContext(
    FiltersDropdownContext,
  );

  const rootClasses = classNames("dropdown-menu", classes?.root, {
    show: hovered || showDropdown || showDropdownOnClickOutside,
  });

  return (
    <div
      style={
        position === "right"
          ? {
              right: "8px",
            }
          : {}
      }
      className={rootClasses}
      data-testid="dropdown"
    >
      <DrawerMask classes={{ root: "d-block d-md-none" }} />
      <div className="dropdown-menu__content-wrapper">
        {children && <div className="dropdown-menu-body">{children}</div>}
        {clearAll && (
          <ClearAll
            text={clearAll?.clearAllText}
            onClear={clearAll?.clearAllCallback}
          />
        )}
      </div>
    </div>
  );
};

export default DropdownMenu;
